import BaseStaticInput from './BaseStaticInput';

export default BaseStaticInput;
